export default __webpack_public_path__ + "static/media/k14.a22a37ff.jpg";